import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../services/base-service.service';
import { FonteDadosEstatisticasLocal } from './fonte-dados-estatisticas-local.model';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class FonteDadosEstatisticasLocalService extends BaseService<FonteDadosEstatisticasLocal, number> {

  constructor(http: HttpClient) {
    super('fonteDadosEstatisticasLocal', http);
  }

  public coletarPorFonteDadosId(fonteDadosId: number): Promise<FonteDadosEstatisticasLocal> {
    return firstValueFrom(this.http.post<FonteDadosEstatisticasLocal>(this.path(`coletarPorFonteDadosId/${fonteDadosId}`), undefined, { headers: this.createJsonHttpHeaders() }));
  }

  public recuperarMaisRecentePorFonteDadosId(fonteDadosId: number): Promise<FonteDadosEstatisticasLocal> {
    return firstValueFrom(this.http.get<FonteDadosEstatisticasLocal>(this.path(`recuperarMaisRecentePorFonteDadosId/${fonteDadosId}`)));
  }
}
